module.exports = __webpack_public_path__ + "static/media/modelBg.60a1b7d1.png";